module.exports = __webpack_public_path__ + "img/methods (7).4a8aa9aa.png";